import { Component, Prop, Ref, SimpleEvent, log } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class PredictiveSearch extends ThemeComponent {

    @Ref() searchForm!: HTMLFormElement;
    @Ref() searchButton!: HTMLButtonElement;
    @Ref() searchInput!: HTMLInputElement;

    private predictiveSearchResults: HTMLDivElement | null;

    constructor() {
        super();
        this.predictiveSearchResults = document.querySelector('#site-header__predictive-search');
    }

    init() {

        this.$listen(this.searchInput, 'input', this.debounce(() => {
            this.onChange();
        }, 300).bind(this));

        this.$listen(this.searchButton, 'click', () => {
            this.searchForm.submit();
        });
    }

    onChange() {
        const searchTerm = this.searchInput.value.trim();

        if (!searchTerm?.length) {
            document.body.classList.add('suggestions--open');
            this.close();
            return;
        }
        document.body.classList.remove('suggestions--open');
        this.getSearchResults(searchTerm);

    }

    getSearchResults(searchTerm: string) {
        // eslint-disable-next-line max-len
        fetch('/search/suggest?q=' + searchTerm + '&resources[type]=product,article,page&section_id=predictive-search&resources[options][unavailable_products]=hide'
        )
            .then((response) => {
                if (!response.ok) {
                    const error = new Error(`${response.status}`);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').
                    querySelector('#shopify-section-predictive-search')?.innerHTML;
                if (this.predictiveSearchResults) {
                    this.predictiveSearchResults.innerHTML = resultsMarkup || '';
                }
                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        if (this.predictiveSearchResults) {
            this.predictiveSearchResults.style.display = 'block';
        }
    }

    close() {
        if (this.predictiveSearchResults) {
            this.predictiveSearchResults.style.display = 'none';
        }
    }

    debounce(fn: () => void, wait: number | undefined) {
        let t: ReturnType<typeof setTimeout>;
        return () => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this), wait);
        };
    }
}
